<template>
  <div id="app">
    <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import services from 'services';

export default {
  async mounted() {
    services.authService.listenUserState((user) => {
      try {
        if (user) {
          this.$store.dispatch('permissions/fetchRolePermissions');
          this.$store.dispatch('auth/fetchCurrentUserProfile', user.uid);
        }
      } catch (e) {
        console.log('ERROR', e);
      }
    });
  },
  data() {
    return {
      isLoading: false,
    };
  },
};
</script>

<style lang="stylus">
  @import '~@/assets/css/main.styl';
</style>
